import moment from 'moment';

export const getDayOfWeek = (date: string) =>
  moment(date).local().format('ddd').concat('. ');
export const getDayOfMonth = (date: string) =>
  moment(date).local().format('DD').toString();
export const getMonthOfYear = (date: string) =>
  moment(date).local().format('MMM');
export const getLocalDate = (date: string) =>
  moment(date).local().format('H:mm');
export const getLocalTime = (date: string) =>
  moment(date).tz(moment.tz.guess()).format('z');
export const getFullDate = (date: string) => moment(date).format('DD.MM.YYYY');

export const getEventDate = (date: string) =>
  `${moment(date).local().format('ddd DD MMM H:mm ')} ${moment()
    .tz(moment.tz.guess())
    .format('z')}`;

export const getEventDateTime = (date: string) => ({
  date: moment(date).local().format('ddd DD MMM'),
  time: `${moment(date).local().format('H:mm')} ${moment()
    .tz(moment.tz.guess())
    .format('z')}`,
});
